import { Component, OnInit } from '@angular/core';
import { ApiService } from '../utilities/services/api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { UntypedFormGroup } from '@angular/forms';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';
import { DatePickerModel } from '@app/components/controls/utilities/models/date-picker-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { AutoCompleteModel } from '@app/components/controls/utilities/models/auto-complete-model';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { DropDownModel } from '@app/components/controls/utilities/models/drop-down-model';
import { OwlDatePickerModel } from '@app/components/controls/utilities/models/owl-date-picker-model';
import { ApiService as ResourceApiService } from '@app/modules/resource/utilities/services/api.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ApiService as WorkgroupApiService } from '@app/modules/workgroup/utilities/services/api.service';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';

@Component({
	selector: 'app-assignment-update',
	templateUrl: './assignment-update.component.html',
	styleUrls: ['./assignment-update.component.scss']
})
export class AssignmentUpdateComponent implements OnInit {

	popupRef;
	action: 'submit' | 'reassign' | 'evaluate' | 'assignees' | 'assign' | 'assignResource' | 'addUserToWorkgroup';
	submitDisable = true;
	formFields: any = [];
	completeDateFields: any = [];
	config = { fxFlex: 100 };
	title;
	formObject;
	assignmentID;
	info = '';
	clearTimeout;
	resourceID;
	resourceDetail;
	deviceDetails;
	showNote: boolean = false;
	formObjectData = {
		form: null,
		fields: []
	};
	activityFields: any = [];
	resource: AutoCompleteModel;
	validationRegex = new RegExp('^(https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\s]{2,}|www\\.[a-zA-Z0-9]+\.[^\\s]{2,})$', 'gi');
	embedData;
	currentUser;
	resourceData;
	newUsers;

	constructor(
		private apiService: ApiService,
		public gfService: GlobalFunctionService,
		public locale: LocaleService,
		private globalApiService: GlobalApiService,
		private appInit: AppInitializerService,
		public detectDevice: DetectDeviceService,
		private baseService: BaseService,
		private resourceApiService: ResourceApiService,
		private popup: MatDialog,
		private workgroupApiService: WorkgroupApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;

		this.baseService.formView = true;
		if (this.action === 'submit') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('submit');
			const notes: TextAreaModel = {
				fieldColumn: 'assigneeNotes',
				fieldCaption: this.locale.translate('notes'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('notes')
			};
			this.formFields = [notes];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'reassign') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('reassign');
			const notes: TextAreaModel = {
				fieldColumn: 'assignerNotes',
				fieldCaption: this.locale.translate('notes'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('notes')
			};
			const completeBy: DatePickerModel = {
				fieldColumn: 'completeByTime',
				additionalMetaData: {
					minDate: 0,
					showLabel: true
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('complete_by'),
				fieldOrder: 4,
				fieldPlaceholder: this.locale.translate('complete_by')
			};
			this.formFields = [notes, completeBy];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'evaluate') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('evaluate');
			const notes: TextAreaModel = {
				fieldColumn: 'evalNotes',
				fieldCaption: this.locale.translate('notes'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('notes')
			};
			const score: TextBoxModel = {
				fieldColumn: 'score',
				fieldCaption: this.locale.translate('score'),
				additionalMetaData: {
					maxChar: 50
					// minChar: 1,
					// maxChar: 2,
					// patternMatch: '^[0-9/]+$'
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null, // ^([0-9]|1[0])$
				value: null,
				fieldPlaceholder: this.locale.translate('score'),
				validationMessage: this.locale.translate('score_error_message')
			};
			this.formFields = [notes, score];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'assign') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('assign');
			this.info = this.locale.translate('assign_info');
			const assignee: AutoCompleteModel = {
				fieldColumn: 'assignee',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 5
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('assign_to'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('users_and_workgroups')
			};
			const completeBy: DatePickerModel = {
				fieldColumn: 'completeByTime',
				additionalMetaData: {
					minDate: 0,
					showLabel: true
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('complete_by'),
				fieldOrder: 3,
				fieldPlaceholder: this.locale.translate('complete_by')
			};
			const notes: TextAreaModel = {
				fieldColumn: 'assignerNotes',
				fieldCaption: this.locale.translate('notes'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: true,
				isReadonly: true,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('notes'),
				fieldOrder: 2
			};
			this.formFields = [assignee, notes];
			this.completeDateFields = [completeBy];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'assignResource') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('assign');
			this.info = this.locale.translate('you_may_assign_internal_or_external_resources');
			this.resource = {
				fieldColumn: 'resource',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off'
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('search_resource_or_paste_link_desc'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('search_resource_or_paste_link_desc')
			};
			const assignee: AutoCompleteModel = {
				fieldColumn: 'assignee',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					max: 5
				},
				fieldType: 'autoComplete',
				isHidden: false,
				isMultiple: true,
				isReadonly: false,
				isRequired: true,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('assign_to'),
				fieldOrder: 1,
				preDefined: true,
				fieldPlaceholder: this.locale.translate('users_and_workgroups')
			};
			const completeBy: DatePickerModel = {
				fieldColumn: 'completeByTime',
				additionalMetaData: {
					minDate: 0,
					showLabel: true
				},
				fieldType: 'date',
				isHidden: false,
				isReadonly: false,
				isRequired: false,
				fieldCaption: this.locale.translate('complete_by'),
				fieldOrder: 3,
				fieldPlaceholder: this.locale.translate('complete_by')
			};
			const notes: TextAreaModel = {
				fieldColumn: 'assignerNotes',
				fieldCaption: this.locale.translate('notes'),
				additionalMetaData: {
					maxChar: 150,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: true,
				isReadonly: true,
				isRequired: false,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('notes'),
				fieldOrder: 2
			};
			const activityType: DropDownModel = {
				fieldColumn: 'activityType',
				fieldType: 'dropDown',
				isHidden: true,
				isMultiple: false,
				isReadonly: true,
				isRequired: false,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('activity_type'),
				fieldPlaceholder: this.locale.translate('activity_type'),
				value: null
			};
			const resourceType = this.baseService.resourceType;
			const options = [];
			for (const data of resourceType) {
				if (['mooc', 'externalEvent'].includes(data.key)) {
					options.push(
						{
							key: data,
							value: data.caption
						}
					);
				}
			}
			activityType.options = options;
			const authority: TextBoxModel = {
				fieldColumn: 'authority',
				fieldCaption: this.locale.translate('authority'),
				additionalMetaData: {
					maxChar: 100
				},
				fieldType: 'textBox',
				isHidden: true,
				isReadonly: true,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('authority'),
				validationMessage: this.locale.translate('authority')
			};
			const date: OwlDatePickerModel = {
				fieldColumn: 'date',
				fieldCaption: this.locale.translate('date'),
				additionalMetaData: {
					pickerType: 'calendar',
					showLabel: true
				},
				fieldType: 'owlDate',
				isHidden: true,
				isReadonly: true,
				isRequired: true,
				fieldPlaceholder: this.locale.translate('date'),
				value: null
			};
			const skills: AutoCompleteModel = {
				fieldColumn: 'skills',
				additionalMetaData: {
					showLabel: true,
					autoFill: 'off',
					defaultWeightage: 1,
					minWeightage: 1,
					showHelp: true
				},
				fieldType: 'autoComplete',
				isHidden: true,
				isMultiple: true,
				isReadonly: true,
				isRequired: false,
				options: [],
				selectedValue: [],
				fieldCaption: this.locale.translate('skills'),
				fieldOrder: 1,
				preDefined: false,
				fieldPlaceholder: this.locale.translate('skills'),
				type: 'weightage'
			};
			// const reimbursementApproval: CheckBoxModel = {
			// 	fieldColumn: 'reimbursementApproval',
			// 	additionalMetaData: {
			// 		showLabel: true
			// 	},
			// 	fieldType: 'checkBox',
			// 	isHidden: true,
			// 	isReadonly: true,
			// 	isRequired: false,
			// 	options: [{
			// 		key: true,
			// 		value: this.locale.translate('enable_approval_for_reimbursement')
			// 	}],
			// 	fieldCaption: null,
			// 	fieldOrder: 2
			// };
			if (this.currentUser.weightageData) {
				skills.additionalMetaData.maxWeightage = this.currentUser.weightageData.map((data) => {
					return {
						key: data.termID,
						value: data.term,
						weightage: data.index,
						description: data.attributes.description
					};
				});
			}
			this.activityFields = [activityType, authority, date, skills];
			this.formFields = [assignee, notes];
			this.completeDateFields = [completeBy];
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		} else if (this.action === 'addUserToWorkgroup') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('add_to_workgroup');
			this.info = this.locale.translate('the_following_assignees_are_not_in_your_workgroup_desc');
			const workgroup: DropDownModel = {
				fieldColumn: 'WGID',
				fieldType: 'dropDown',
				isHidden: false,
				isMultiple: false,
				isReadonly: false,
				isRequired: true,
				options: [],
				additionalMetaData: {},
				fieldCaption: this.locale.translate('select_a_workgroup'),
				fieldPlaceholder: this.locale.translate('select_a_workgroup'),
				value: null
			};
			const apiData = {};
			const headers: any = {};
			this.workgroupApiService.getList(apiData, headers).subscribe(
				(response) => {
					if (response && response.records && response.records.length) {
						workgroup.options = response.records.map(resp => {
							return {
								key: resp.groupID,
								value: resp.groupName
							};
						});
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			).add(() => {
				this.formFields = [
					workgroup
				];
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});
		}
	}

	formObjectReader(record) {
		// this.formObject = record;
		const form: UntypedFormGroup = this.formObjectData.form;
		if (['assign', 'assignResource'].includes(this.action) && form.controls.assignee) {
			let subscribe;
			const userField = this.formFields.find((items) => items.fieldColumn === 'assignee');
			form.controls.assignee.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							// const userFilter: any = { $and: [] };
							// const splitVal = controlResp.toLowerCase().split(' ');
							// for (const value of splitVal) {
							//   userFilter.$and.push({
							//     $or: {
							//       '$accountDetail.firstName$': { $substring: value },
							//       '$accountDetail.lastName$': { $substring: value }
							//     }
							//   });
							// }
							const apiData = {
								searchString: controlResp,
								includeWorkGroup: 1
							};
							const header: any = {};
							let selectedUser = [];
							if (userField.selectedValue.length) {
								userField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && !items.key.isWorkGroup) {
										selectedUser.push(items.key.ID);
									}
								});
							}
							let selectedWorkgroup = [];
							if (userField.selectedValue.length) {
								userField.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete && items.key.isWorkGroup) {
										selectedWorkgroup.push(items.key.ID);
									}
								});
							}
							if (this.resourceDetail && this.resourceDetail.authors && this.resourceDetail.authors.length) {
								for (const author of this.resourceDetail.authors) {
									selectedUser.push(author.userID);
								}
							}
							let method;
							if (this.action === 'assign') {
								method = this.globalApiService.getUsers(apiData, header);
							} else {
								method = this.globalApiService.getWorkGroupUsers(apiData, header);
							}
							subscribe = method.subscribe((response) => {
								if (response) {
									if (selectedUser.length) {
										response.records = response.records.filter(items => {
											if (!selectedUser.includes(items.userID)) {
												return items;
											}
										});
									}
									if (selectedWorkgroup.length) {
										if (response.workgroup && response.workgroup.length) {
											response.workgroup = response.workgroup.filter(items => {
												if (!selectedWorkgroup.includes(items.groupID)) {
													return items;
												}
											});
										}
									}
									let options = [];
									if (response.workgroup && response.workgroup.length) {
										options = response.workgroup.map((data) => {
											return {
												key: {
													ID: data.groupID,
													isWorkGroup: true
												},
												value: data.groupName,
												prefix: {
													type: 'svgIcon',
													value: 'workgroup'
												}
											};
										});
									}
									options = options.concat(response.records.map((data) => {
										return {
											key: {
												ID: data.userID,
												isWorkGroup: false
											},
											value: `${data.firstName}${data.lastName
												? ' ' + data.lastName
												: ''}`,
											prefix: {
												type: 'image',
												value: data.profilePicURL
											},
											shortInfo: this.baseService.getUserShortInfo(data)
										};
									}));
									userField.options = options;
								} else {
									userField.options = [];
								}
							},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									userField.options = [];
								}
							);
						} else {
							userField.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	resourceFormObjectReader(record) {
		const form: UntypedFormGroup = this.formObjectData.form;
		if (form.controls.resource) {
			let subscribe;
			const resource = this.resource;
			form.controls.resource.valueChanges.subscribe(controlResp => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					if (this.embedData) {
						this.resource.additionalMetaData.loadOptions = false;
						this.resource.preDefined = false;
						return false;
					}
					if (controlResp && typeof controlResp === 'object' && controlResp.isAdd && controlResp.key.resourceID) {
						for (const field of this.activityFields) {
							field.isReadonly = true;
							field.isHidden = true;
							field.isRequired = false;
							this.formObjectData.form.controls[field.fieldColumn].disable({ emitEvent: false });
							this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
							// if (field.fieldColumn === 'reimbursementApproval') {
							// 	this.formObjectData.form.controls[field.fieldColumn].patchValue([false], { emitEvent: false });
							// } else {
							// 	this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
							// }
							if (field.fieldColumn === 'skills') {
								field.selectedValue = [];
							}
						}
						this.embedData = null;

						this.resourceData = controlResp.key;
						let finalData: any = {};
						if (this.resourceData && this.resourceData.resourceTypeID) {
							this.resourceData.resourceTypeID = this.baseService.referenceType('resourceType', this.resourceData.resourceTypeID);
							this.resourceData.type = this.resourceData.resourceTypeID.caption;

							if (this.resourceData.resourceTypeID.key === 'answer') {
								const cardData: QuestionCard = {
									title: this.resourceData.title,
									// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
									thumbnail: '',
									// removable: true
								};
								// if (data.authors && data.authors.length) {
								// 	cardData.thumbnail = data.authors[0].profilePicURL;
								// 	cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
								// 		? ' ' + data.authors[0].lastName
								// 		: ''}`;
								// 	if (data.authors.length > 1) {
								// 		cardData.usersCount = (data.authors.length - 1);
								// 	}
								// }

								finalData = cardData;
							} else if (this.resourceData.resourceTypeID.key === 'playlist') {
								const cardData: PlaylistCard = {
									title: this.resourceData.title,
									// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
									// type: resource.resourceType.caption,
									thumbnail: '',
									// removable: true
									// playlistItemCount: data.count
								};

								finalData = cardData;
							} else if (['internalEvent', 'externalEvent'].includes(this.resourceData.resourceTypeID.key)) {
								const cardData: EventCard = {
									thumbnail: '',
									title: this.resourceData.title,
									eventType: (this.resourceData.resourceTypeID && this.resourceData.resourceTypeID.key) ? this.resourceData.resourceTypeID.key : null,
									// removable: true
								};
								if (this.resourceData.resourceTypeID) {
									// if (data.infoFields) {
									// 	if (data.resourceType.key === 'internalEvent') {
									// 		if (data.infoFields.time) {
									// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
									// 		}
									// 		if (data.infoFields.date.length) {
									// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
									// 		}
									// 	} else {
									// 		if (data.infoFields.date) {
									// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
									// 		}
									// 	}
									// }
								}

								finalData = cardData;
							} else {
								const cardData: ContentImageCard = {
									title: this.resourceData.title,
									// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
									thumbnail: '',
									// removable: true
								};
								finalData = cardData;

							}

							finalData.type = this.resourceData.resourceTypeID.caption;

						}

						finalData.resourceID = this.resourceData.resourceID;

						if (this.resourceData.resource.hasOwnProperty('duration')) {
							finalData.duration = this.resourceData.resource.duration;
						}

						if (this.resourceData.resource && this.resourceData.resource.thumbnail && this.resourceData.resourceTypeID && this.resourceData.resourceTypeID.key !== 'answer') {
							finalData.thumbnail = this.resourceData.resource.thumbnail;
						}
						if (this.resourceData.resourceFormat) {
							this.resourceData.resourceFormat = this.baseService.referenceType('resourceFormat', this.resourceData.resourceFormat);
							finalData.format = this.resourceData.resourceFormat.key;
							if (finalData.thumbnail === '') {
								finalData.thumbnail = this.resourceData.resourceFormat.image;
							}
						}

						this.resourceData = finalData;
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							if (this.validationRegex.test(controlResp)) {
								const apiData = {
									url: controlResp
								};
								const header: any = {};
								form.controls.resource.disable({ emitEvent: false });
								resource.options = [];
								this.resourceData = null;
								subscribe = this.globalApiService.getEmbedData(apiData, header).subscribe(
									(response) => {
										if (response) {
											this.resource.value = {
												isAdd: true,
												isDelete: false,
												key: response.title,
												value: response.title
											};
											form.controls.resource.patchValue(this.resource.value, { emitEvent: false });
											this.resource.selectedValue = [this.resource.value];
											for (const field of this.activityFields) {
												if (['activityType', 'skills'].includes(field.fieldColumn)) {
													if (field.fieldColumn === 'skills') {
														field.selectedValue = [];
													}
													field.isReadonly = false;
													field.isRequired = true;
													field.isHidden = false;
													this.formObjectData.form.controls[field.fieldColumn].enable({ emitEvent: false });
													this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
													// if (field.fieldColumn === 'reimbursementApproval') {
													// 	this.formObjectData.form.controls[field.fieldColumn].patchValue([false], { emitEvent: false });
													// } else {
													// 	this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
													// }
												}
											}
											this.embedData = response;
										} else {
											this.embedData = null;
										}
										form.controls.resource.enable({ emitEvent: false });
									},
									(error) => {
										form.controls.resource.enable({ emitEvent: false });
										form.controls.resource.setErrors({
											incorrect: {
												msg: this.locale.translate('enter_valid_url')
											}
										});
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										this.embedData = null;
									}
								).add(() => {
									// form.controls.resource.enable({ emitEvent: false });
								});
							} else {
								this.embedData = null;
								const apiData = {
									searchString: controlResp
								};
								const header: any = {
									lanCode: sessionStorage.getItem('locale') || 'en'
								};
								subscribe = this.globalApiService.searchByResource(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											resource.options = response.records.map(record => {
												return {
													key: record,
													value: record.title
												};
											});
										} else {
											resource.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										resource.options = [];
									}
								);
							}
						} else {
							resource.options = [];
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
	}

	activityFormObjectReader(record) {
		let subscribe;
		const skills = this.activityFields.find((items) => items.fieldColumn === 'skills');
		const form: UntypedFormGroup = record.form;
		if (form.controls.skills) {
			form.controls.skills.valueChanges.subscribe((controlResp) => {
				if (navigator.onLine) {
					if (subscribe && !subscribe['closed']) {
						subscribe.unsubscribe();
					}
					if (this.clearTimeout) {
						clearTimeout(this.clearTimeout);
					}
					this.clearTimeout = setTimeout(() => {
						if (controlResp && typeof controlResp === 'string') {
							const apiData = {
								searchString: controlResp,
								termsetid: 1
							};
							const header: any = {};
							let selectedValue = [];
							if (skills.selectedValue.length) {
								skills.selectedValue.map(items => {
									if (items.isAdd && !items.isDelete) {
										selectedValue.push(items.key);
									}
								});
							}
							subscribe = this.globalApiService.getTerm(apiData, header).subscribe(
								(response) => {
									if (response && response.records.length) {
										if (selectedValue.length) {
											response.records = response.records.filter(items => {
												if (!selectedValue.includes(items.termID)) {
													return items;
												}
											});
										}
										skills.options = response.records.map((data) => {
											return {
												key: data.termID,
												value: data.term
											};
										});
									} else {
										skills.options = [];
									}
								},
								(error) => {
									this.gfService.errorHandler(error, {
										snackBar: {
											position: 'before'
										}
									});
									skills.options = [];
								}
							);
						} else {
							if (typeof controlResp === 'object') {
								skills.options = [];
							}
						}
					}, this.appInit.configuration.searchDelay);
				}
			});
		}
		if (form.controls.activityType) {
			form.controls.activityType.valueChanges.subscribe(controlResp => {
				if (controlResp) {
					const authority = this.activityFields.find(items => items.fieldColumn === 'authority');
					const date = this.activityFields.find(items => items.fieldColumn === 'date');
					if (controlResp.key === 'mooc') {
						if (authority) {
							authority.isHidden = false;
							authority.isReadonly = false;
							this.formObjectData.form.controls[authority.fieldColumn].enable({ emitEvent: false });
							let patchValue = null;
							if (this.embedData) {
								const link = new URL(this.embedData.link);
								patchValue = link.hostname.split('.');
								if (link.hostname && link.hostname.split('.').length) {
									patchValue = link.hostname.split('.')[1];
								}
							}
							this.formObjectData.form.controls[authority.fieldColumn].patchValue(patchValue, { emitEvent: false });
						}
						if (date) {
							date.isHidden = true;
							date.isReadonly = true;
							this.formObjectData.form.controls[date.fieldColumn].disable({ emitEvent: false });
							this.formObjectData.form.controls[date.fieldColumn].patchValue(null, { emitEvent: false });
						}
					} else if (controlResp.key === 'externalEvent') {
						if (date) {
							date.isHidden = false;
							date.isReadonly = false;
							this.formObjectData.form.controls[date.fieldColumn].enable({ emitEvent: false });
							this.formObjectData.form.controls[date.fieldColumn].patchValue(null, { emitEvent: false });
						}
						if (authority) {
							authority.isHidden = true;
							authority.isReadonly = true;
							this.formObjectData.form.controls[authority.fieldColumn].disable({ emitEvent: false });
							this.formObjectData.form.controls[authority.fieldColumn].patchValue(null, { emitEvent: false });
						}
					}
				}
			});
		}
	}

	removeEmbed() {
		if (navigator.onLine) {
			this.formObjectData.form.controls.resource.patchValue(null, { emitEvent: false });
			this.resource.selectedValue = [];
			this.embedData = null;
			this.resourceData = null;
			this.resource.additionalMetaData.loadOptions = true;
			this.resource.preDefined = true;
			for (const field of this.activityFields) {
				field.isReadonly = true;
				field.isHidden = true;
				field.isRequired = false;
				this.formObjectData.form.controls[field.fieldColumn].disable({ emitEvent: false });
				this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
				// if (field.fieldColumn === 'reimbursementApproval') {
				// 	this.formObjectData.form.controls[field.fieldColumn].patchValue([false], { emitEvent: false });
				// } else {
				// 	this.formObjectData.form.controls[field.fieldColumn].patchValue(null, { emitEvent: false });
				// }
				if (field.fieldColumn === 'skills') {
					field.selectedValue = [];
				}
			}
		}
	}

	showFields(fieldType: string) {
		if (fieldType === 'note') {
			const assignerNotes = this.formFields.find(items => items.fieldColumn === 'assignerNotes');
			if (assignerNotes) {
				assignerNotes.isReadonly = false;
				assignerNotes.isHidden = false;
				this.formObjectData.form.controls.assignerNotes.enable();
				this.showNote = true;
			}
		}

	}

	update() {
		if (navigator.onLine) {
			if (this.action === 'submit') {
				this.submit();
			} else if (this.action === 'reassign') {
				this.reassign();
			} else if (this.action === 'evaluate') {
				this.evaluate();
			} else if (this.action === 'assign') {
				this.assign();
			} else if (this.action === 'assignResource') {
				this.assignResource();
			} else if (this.action === 'addUserToWorkgroup') {
				this.addUserToWorkgroup();
			}
		}
	}

	assign() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('assignCard');
			this.submitDisable = true;
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);

				if (!formValue.assignerNotes) {
					delete formValue.assignerNotes;
				}

				formValue.type = 1;
				formValue.payloadResourceID = this.resourceDetail.resourceID;
				if (this.resourceDetail.resourceTypeID.key === 'knowledgecard') {
					formValue.taskGroup = 1;
				} else if (this.resourceDetail.resourceTypeID.key === 'course') {
					formValue.taskGroup = 4;
				}
				const assignee = [];
				for (const data of formValue.assignee) {
					if (data.isAdd && !data.isDelete && !data.key.isWorkGroup) {
						assignee.push(data.key.ID);
					}
				}
				const workgroupID = [];
				for (const data of formValue.assignee) {
					if (data.isAdd && !data.isDelete && data.key.isWorkGroup) {
						workgroupID.push(data.key.ID);
					}
				}
				formValue.assignee = assignee;
				formValue.workgroup = workgroupID;
				formValue.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					formValue.notificationType = 2;
				}
				this.apiService
					.add(formValue)
					.subscribe(
						(response) => {
							if (response) {
								this.baseService.logUserActivity('assign', 'engagement', [''], { resourceData: this.resourceDetail });
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('resource_assigned'),
									icon: 'check_circle_outline',
									position: 'before'
								});
								this.workgroupProcess(formValue, response);
							}
						},
						(error) => {
							this.submitDisable = false;
							this.popupRef.componentInstance.popupLoader = false;
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'EMPTY_USERID_OR_WORKGROUPID') {
								error.error = this.locale.translate('workgroup_has_no_users');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'assignCard'
								},
								form: this.formObjectData.form
							});
						}
					)
					.add(() => {
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	workgroupProcess(formValue, response) {
		if (formValue && formValue.assignee && formValue.assignee.length) {
			const apiData = {
				memberID: formValue.assignee
			};
			const headers: any = {};
			this.apiService.getWorkgroupIsMember(apiData, headers).subscribe(
				(workgroupResponse) => {
					this.popupRef.close(this.gfService.JSONMerge(formValue, response.recordID));
					if (workgroupResponse && workgroupResponse.records && workgroupResponse.records.length) {
						const newUsers = [];
						for (const user of workgroupResponse.records) {
							if (user.isWorkgroup === 0) {
								user.name = `${user.firstName}${user.lastName
									? ' ' + user.lastName
									: ''}`;
								newUsers.push(user);
							}
						}
						if (newUsers && newUsers.length) {
							const dialogRef = this.popup.open(PopupComponent, {
								panelClass: ['custom-panel'],
								data: {
									action: 'dynamic',
									popup: true,
									component: AssignmentUpdateComponent,
									componentData: [
										{
											variableName: 'action',
											value: 'addUserToWorkgroup'
										},
										{
											variableName: 'resourceDetail',
											value: this.resourceDetail
										},
										{
											variableName: 'newUsers',
											value: newUsers
										}
									]
								},
								disableClose: true,
								maxWidth: '860px',
								autoFocus: true
							});
							dialogRef.afterClosed().subscribe(async (result) => {
								if (result && typeof result === 'object') {

								}
							});
						}
					}
				},
				(error) => {

				}
			).add(() => { });
		} else {
			this.popupRef.close(this.gfService.JSONMerge(formValue, response.recordID));
			this.submitDisable = false;
			this.popupRef.componentInstance.popupLoader = false;
		}
	}

	addUserToWorkgroup() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('assignCard');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const apiData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				const headers = {};
				apiData.toUserIDARRAY = this.newUsers.map(resp => {
					return resp.userID
				});
				this.workgroupApiService.saveInvites(apiData, headers).subscribe(
					(response) => {
						this.popupRef.close(apiData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('users_added_to_workgroup'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
							error.error = this.locale.translate('you_have_already_sent_invites_desc');
						}
						this.gfService.errorHandler(error, {
							alert: {
								id: 'assignCard'
							},
							form: this.formObjectData.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	submit() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('assignCard');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				formData.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					formData.notificationType = 2;
				}
				const headers = {};
				// formData = this.gfService.JSONBuilder(formData, [null, undefined]);
				this.apiService.submit(formData, this.assignmentID, headers).subscribe(
					(response) => {
						this.baseService.logUserActivity('assignmentsubmission', 'both', [''], { resourceData: this.resourceDetail });
						this.popupRef.close(formData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('assignment_submitted'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'assignCard'
							},
							form: this.formObjectData.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	reassign() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('assignCard');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				formData.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					formData.notificationType = 2;
				}
				// this.popupRef.close(true);
				// return;
				// formData = this.gfService.JSONBuilder(formData, [null, undefined]);
				const headers = {};
				this.apiService.reassign(formData, this.assignmentID, headers).subscribe(
					(response) => {
						this.baseService.logUserActivity('reassign', 'engagement', [''], { resourceData: this.resourceDetail });
						this.popupRef.close(this.gfService.JSONMerge(formData, response));
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('assignment_reassigned'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'assignCard'
							},
							form: this.formObjectData.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	evaluate() {
		if (this.formObjectData && this.formObjectData.form) {
			this.submitDisable = true;
			this.gfService.alertClear('assignCard');
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formData: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				formData.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					formData.notificationType = 2;
				}
				// this.popupRef.close(formData);
				// return;
				// formData = this.gfService.JSONBuilder(formData, [null, undefined]);
				const headers = {};
				formData.score = parseFloat(formData.score);
				this.apiService.evaluate(formData, this.assignmentID, headers).subscribe(
					(response) => {
						// this.baseService.logUserActivity('evaluate', ['']);
						this.popupRef.close(formData);
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('assignment_evaluation_saved'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							alert: {
								id: 'assignCard'
							},
							form: this.formObjectData.form
						});
					}
				)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	assignResource() {
		if (this.formObjectData && this.formObjectData.form) {
			this.gfService.alertClear('assignCard');
			this.submitDisable = true;
			if (this.formObjectData.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObjectData.form.getRawValue(),
					this.formObjectData.fields
				);
				const assignee = [];
				for (const data of formValue.assignee) {
					if (data.isAdd && !data.isDelete && !data.key.isWorkGroup) {
						assignee.push(data.key.ID);
					}
				}
				const workgroupID = [];
				for (const data of formValue.assignee) {
					if (data.isAdd && !data.isDelete && data.key.isWorkGroup) {
						workgroupID.push(data.key.ID);
					}
				}
				if (this.embedData) {
					const apiData: any = {
						title: this.embedData.title,
						description: this.embedData.description,
						authors: [
							{ id: this.currentUser.userID }
						],
						resourceTypeID: formValue.activityType.value,
						languageCode: 'en',
						skills: [],
						keywords: [],
						resourceFormat: this.baseService.resourceFormat.find(items => items.key === 'link').value,
						infoFields: {},
						resource: {
							link: this.embedData.link,
							thumbnail: this.embedData.image
						}
					};
					const skills = [];
					const skillID = [];
					for (const skill of formValue.skills) {
						if (!skill.value && skill.isAdd && !skill.isDelete) {
							skillID.push(
								{
									skill: {
										key: skill.key
									}
								}
							);
							skills.push({
								skill: skill.key,
								skillLevel: skill.progress
							});
						} else if (skill.value) {
							if (skill.value.isAdd && !skill.value.isDelete) {
								const skillData: any = { skillName: skill.value.value };
								if (skill.value.progress) {
									skillData.skillLevel = skill.value.progress;
								}
								skills.push(skillData);
							}
						}
					}
					apiData.skills = skills;
					if (formValue.authority) {
						apiData.infoFields = {
							authority: formValue.authority
						};
					} else if (formValue.date) {
						apiData.infoFields = {
							date: Date.parse(formValue.date)
						};
					}
					apiData.infoFields.reimbursementApproval = false;
					// if (Array.isArray(formValue.reimbursementApproval)) {
					// 	if (formValue.reimbursementApproval[0] !== null) {
					// 		apiData.infoFields.reimbursementApproval = formValue.reimbursementApproval[0];
					// 	} else {
					// 		apiData.infoFields.reimbursementApproval = false;
					// 	}
					// }
					apiData.settings = {
						visibility: {
							user: assignee,
							workgroupID
						}
					};
					let resourceApiData: any = { ...apiData };
					resourceApiData = this.gfService.convertToFormData(resourceApiData);
					const headers: any = {};
					this.resourceApiService.saveResource(resourceApiData, headers).subscribe(
						(response) => {
							if (response) {
								apiData.assignee = assignee;
								apiData.workgroup = workgroupID;
								apiData.payloadResourceID = response.recordID;
								apiData.completeByTime = formValue.completeByTime;
								apiData.assignerNotes = formValue.assignerNotes;
								this.resourceDetail = {
									resourceID: response.recordID,
									resourceTypeID: apiData.resourceTypeID,
									resourceFormat: apiData.resourceFormat,
									skills: skillID
								};
								this.createAssignment(apiData);
							}
						},
						(error) => {
							this.submitDisable = false;
							this.popupRef.componentInstance.popupLoader = false;
							this.gfService.errorHandler(error, {
								alert: {
									id: 'assignCard'
								},
								form: this.formObjectData.form
							});
						}
					)
						.add(() => { });
				} else {
					this.resourceDetail = { ...formValue.resource[0].key };
					formValue.assignee = assignee;
					formValue.workgroup = workgroupID;
					formValue.payloadResourceID = this.resourceDetail.resourceID;
					// this.resourceDetail.resourceTypeID = this.baseService.referenceType('resourceType', this.resourceDetail.resourceTypeID);
					if (this.resourceDetail.resourceTypeID.key === 'knowledgecard') {
						formValue.taskGroup = 1;
					} else if (this.resourceDetail.resourceTypeID.key === 'course') {
						formValue.taskGroup = 4;
					}
					this.createAssignment(formValue);
				}
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObjectData.fields, this.formObjectData.form);
				this.submitDisable = false;
			}
		}
	}

	createAssignment(formValue) {
		const headers: any = {};
		const apiData: any = {
			assignee: formValue.assignee,
			completeByTime: formValue.completeByTime,
			payloadResourceID: formValue.payloadResourceID,
			type: 1,
			workgroup: formValue.workgroup
		};
		apiData.notificationType = 1;
		if (this.deviceDetails.browserName === 'Safari') {
			apiData.notificationType = 2;
		}
		if (formValue.taskGroup) {
			apiData.taskGroup = formValue.taskGroup;
		}
		if (formValue.assignerNotes) {
			apiData.assignerNotes = formValue.assignerNotes;
		}
		this.apiService.add(apiData, headers).subscribe(
			(response) => {
				if (response) {
					this.baseService.logUserActivity('assign', 'engagement', [''], { resourceData: this.resourceDetail });
					this.popupRef.close(this.gfService.JSONMerge(formValue, response.recordID));
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('resource_assigned'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				}
			},
			(error) => {
				if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'EMPTY_USERID_OR_WORKGROUPID') {
					error.error = this.locale.translate('workgroup_has_no_users');
				}
				this.gfService.errorHandler(error, {
					alert: {
						id: 'assignCard'
					},
					form: this.formObjectData.form
				});
			}
		)
			.add(() => {
				this.submitDisable = false;
				this.popupRef.componentInstance.popupLoader = false;
			});
	}
}
